import { render, staticRenderFns } from "./CardFavorite.vue?vue&type=template&id=7327a4a0&scoped=true&"
import script from "./CardFavorite.vue?vue&type=script&lang=js&"
export * from "./CardFavorite.vue?vue&type=script&lang=js&"
import style0 from "./CardFavorite.vue?vue&type=style&index=0&id=7327a4a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7327a4a0",
  null
  
)

export default component.exports